Datepicker = {

	customDatepickers: function() {
		var customDatepickers = $("input.customDatepicker");
		$(customDatepickers).each(function(index, customDatepicker){
			$(this).datepicker("option", {minDate: "+" + $(this).attr("minDate") + "D"});
		})
	},

	init: function() {

		$("#ui-datepicker-div").remove()
		$(".ui-datepicker-inline").remove()

		$( ".date" ).datepicker({
			minDate: "+1D",
			dateFormat: "dd.mm.yy",
			beforeShowDay: function(date) {
        		var day = date.getDay();
       			 return [(day != 0), ''];
    		}
		});

		Datepicker.customDatepickers();

		$('.ui-datepicker').css('display','none');

		$.datepicker.regional['sk'] = {
			closeText: 'Zavrieť',
			prevText: '&lt; Predchádzajúci',
			nextText: 'Nasledujúci &gt;',
			currentText: 'Dnes',
			monthNames: [
				'Január',
				'Február',
				'Marec',
				'Apríl',
				'Máj',
				'Jún',
				'Júl',
				'August',
				'September',
				'Október',
				'November',
				'December'
			],
			monthNamesShort: [
				'Jan',
				'Feb',
				'Mar',
				'Apr',
				'Máj',
				'Jún',
				'Júl',
				'Aug',
				'Sep',
				'Okt',
				'Nov',
				'Dec'
			],
			dayNames: [
				'Nedeľa',
				'Pondelok',
				'Utorok',
				'Streda',
				'Štvrtok',
				'Piatok',
				'Sobota'
			],
			dayNamesShort: [
				'Ned',
				'Pon',
				'Uto',
				'Str',
				'Štv',
				'Pia',
				'Sob'
			],
			dayNamesMin: [
				'Ne',
				'Po',
				'Ut',
				'St',
				'Št',
				'Pia',
				'So'
			],
			dateFormat: 'd.m.yy',
			firstDay: 0,
			isRTL: false
		};
		$.datepicker.setDefaults($.datepicker.regional['sk']);
	}

}
